'use client'

import { forwardRef } from 'react'
import { Provider, Root, Trigger, Content, Portal } from '@radix-ui/react-tooltip'
import { cn } from '@/lib/utils'
import { SURFACE_MOTION_CLASS } from '@/components/ui/motion'
const TooltipProvider = ({ delayDuration = 200, skipDelayDuration = 0, ...props }) => (
  <Provider delayDuration={delayDuration} skipDelayDuration={skipDelayDuration} {...props} />
)
const Tooltip = (props) => <Root disableHoverableContent {...props} />
const TooltipTrigger = Trigger
const TooltipContent = forwardRef(({ className, sideOffset = 4, ...props }, ref) => (
  <Portal>
    <Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        SURFACE_MOTION_CLASS,
        'z-50 overflow-hidden rounded-md border border-border/40 bg-popover px-2 py-1 text-[11px] font-medium leading-none text-popover-foreground shadow-md pointer-events-none select-none max-w-[280px] origin-(--radix-tooltip-content-transform-origin)',
        className,
      )}
      {...props}
    />
  </Portal>
))
TooltipContent.displayName = Content.displayName
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
